import React from "react";
import TextField from '@mui/material/TextField';

const Input = ({ name, label, error, ...rest }) => {
  return (
    <React.Fragment>
      <TextField fullWidth label={label} variant="standard" name={name} id={name} {...rest} error={!!error} helperText={error}
      
      InputProps={{
        style: {
          fontFamily: "inherit",
        },
      }}
      
      InputLabelProps={{
        style: {
          fontFamily: "inherit",
        },
      }}
      />
    </React.Fragment>
  );
};

export default Input;
